import { render, staticRenderFns } from "./payfor-check.vue?vue&type=template&id=243763c9&"
import script from "./payfor-check.vue?vue&type=script&lang=js&"
export * from "./payfor-check.vue?vue&type=script&lang=js&"
import style0 from "./payfor-check.vue?vue&type=style&index=0&id=243763c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports